import A from './types';
import findIndex from 'lodash/findIndex';
import remove from 'lodash/remove';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  accountInfo: {},
  accountUserList: {
    jumptoRoot: false,
    loading: false,
    error: false,
    data: [],
  },
  paymentHistoryMsg: {},
  paymentNextBillDate: {},
  addAccountControlData: {},
  editAccountControlData: {},
};

const processData = (arr, obj, id) => {
  const num = (arr && arr.length) ? findIndex(arr, (val) => Number(val.id) === Number(id)) : -1;
  let newArr = arr ? arr : [];
  if (num >= 0) {
    newArr[num] = isEmpty(obj) ? obj : Object.assign(newArr[num], obj);
  } else {
    newArr = isEmpty(obj) ? newArr.push(obj) : newArr;
  }
  const arrDeleteEmpty = remove(newArr, (val) => !isEmpty(val));
  return arrDeleteEmpty;
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.ADMIN_ACCOUNT_INFO: {
      if (action.pending) {
        return {
          ...state,
          accountInfo: {
            loading: true,
            error: false,
            data: state.accountInfo.data,
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          accountInfo: {
            loading: false,
            error: action.payload.message,
            data: state.accountInfo.data,
          },
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          accountInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        accountInfo: {
          loading: false,
          error: action.payload.message,
          data: state.accountInfo.data,
        },
      };
    }
    case A.ACCOUNT_INFO_INIT: {
      return {
        ...state,
        accountInfo: {},
      };
    }
    case A.ACCOUNT_LIST: {
      if (action.pending) {
        return {
          ...state,
          accountUserList: {
            ...state.accountUserList,
            loading: false,
            error: false,
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          accountUserList: {
            ...state.accountUserList,
            loading: false,
            error: action.payload.message,
          },
        };
      }
      return {
        ...state,
        accountUserList: {
          loading: false,
          error: false,
          data: action.payload.data,
        },
      };
    }
    case A.USER_ROLE_CHANGE_VALUE: {
      const id = action.payload.id;
      const obj = {
        changeBtn: true,
        disable: false,
        error: false,
        userRole: action.payload.userRole,
      };
      return {
        ...state,
        accountUserList: {
          loading: false,
          error: false,
          data: processData(state.accountUserList.data, obj, id),
        },
      };
    }
    case A.SAVE_USER_ROLE_CHANGE: {
      const id = action.meta.id;
      const changeBtn = action.meta.changeBtn;
      if (action.pending) {
        const obj = {
          changeBtn: changeBtn ? changeBtn : false,
          disable: true,
          error: false,
        };
        return {
          ...state,
          editAccountControlData: {
            disable: true,
            error: false,
          },
          accountUserList: Object.assign(
            {},
            state.accountUserList,
            {data: processData(state.accountUserList.data, obj, id)}
          ),
        };
      }
      if (action.error) {
        const obj = {
          changeBtn: changeBtn ? changeBtn : false,
          disable: false,
          error: true,
        };
        return {
          ...state,
          editAccountControlData: {
            disable: false,
            error: true,
          },
          accountUserList: Object.assign(
            {},
            state.accountUserList,
            {data: processData(state.accountUserList.data, obj, id)}
          ),
        };
      }
      const obj = () => {
        if (action.payload.message.toLowerCase() === 'success') {
          return {
            changeBtn: false,
            disable: false,
            error: false,
          };
        }
        return {
          changeBtn: false,
          disable: false,
          error: action.payload.message,
        };
      };
      return {
        ...state,
        editAccountControlData: {
          disable: false,
          error: action.payload.message !== 'success',
        },
        accountUserList: Object.assign(
          {},
          state.accountUserList,
          {
            jumptoRoot: action.payload.code === 403 ? true : false,
            data: processData(state.accountUserList.data, obj(), id)
          }
        ),
      };
    }
    case A.DELETE_ACCOUNT_USER: {
      const id = action.meta.id;
      const changeBtn = action.meta.changeBtn;
      if (action.pending) {
        const obj = {
          changeBtn: changeBtn ? changeBtn : false,
          disable: true,
          error: false,
        };
        return {
          ...state,
          editAccountControlData: {
            disable: true,
            error: false,
          },
          accountUserList: Object.assign(
            {},
            state.accountUserList,
            {data: processData(state.accountUserList.data, obj, id)}
          ),
        };
      }
      if (action.error) {
        const obj = {
          changeBtn: changeBtn ? changeBtn : false,
          disable: false,
          error: true,
        };
        return {
          ...state,
          editAccountControlData: {
            disable: false,
            error: true,
          },
          accountUserList: Object.assign(
            {},
            state.accountUserList,
            {data: processData(state.accountUserList.data, obj, id)}
          ),
        };
      }
      const obj = () => {
        if (action.payload.message.toLowerCase() === 'success') {
          return {
            changeBtn: false,
            disable: false,
            error: false,
          };
        }
        return {
          changeBtn: false,
          disable: false,
          error: action.payload.message,
        };
      };
      return {
        ...state,
        editAccountControlData: {
          disable: false,
          error: action.payload.message !== 'success',
        },
        accountUserList: Object.assign(
          {},
          state.accountUserList,
          {
            jumptoRoot: action.payload.code === 403 ? true : false,
            data: processData(state.accountUserList.data, obj(), id)
          }
        ),
      };
    }
    case A.ADD_ACCOUNT_USER: {
      if (action.pending) {
        return {
          ...state,
          addAccountControlData: {
            disable: true,
            error: false,
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          addAccountControlData: {
            disable: false,
            error: action.payload.message,
          },
        };
      }
      return {
        ...state,
        addAccountControlData: {
          disable: false,
          error: action.payload.message,
        },
        accountUserList: Object.assign(
          {},
          state.accountUserList,
          {
            jumptoRoot: action.payload.code === 403 ? true : false
          }
        ),
      };
    }
    case A.ASYNG_ERROR_HIDE: {
      return {
        ...state,
        [action.payload.type]: {
          ...[action.payload.type],
          error: false,
          childError: false,
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/adminAccountPage/reducer.js